import { getDateRequestData } from "../utils/date";
import axiosService from "./axios-service";

export const getPayout = async (client, month, year, channel) => {
  var client_id = client;
  var channel = channel;
  var data = { client_id, ...getDateRequestData(month, year), channel };
  try {
    const response = await axiosService.post(
      "/sales/incentive/usr_payout",
      data,
    );

    return response.data || response || {};
  } catch (error) {
    console.error(error);
    return {};
  }
};

export const getTarget = async (client_id, month, year, channel) => {
  var monthly;
  var quarterly;
  var data;
  var channel = channel;
  if (month === "1Q" || month === "2Q" || month === "3Q" || month === "4Q") {
    quarterly = `${month.slice(0, 1)}-${year}`;
    data = { client_id, quarterly, channel };
  } else {
    monthly = `${month}-${year}`;
    data = { client_id, monthly, channel };
  }
  try {
    const response = await axiosService.post(
      "/sales/incentive/target-chart",
      data,
    );

    return response.data || response || {};
  } catch (error) {
    console.error(error);
    return {};
  }
};

export const getHBB = async (client_id, month, year, channel) => {
  var monthly;
  var quarterly;
  var data;
  channel = channel;
  var product = "HBB";
  if (month === "1Q" || month === "2Q" || month === "3Q" || month === "4Q") {
    quarterly = `${month.slice(0, 1)}-${year}`;
    data = { client_id, quarterly, product, channel };
  } else {
    monthly = `${month}-${year}`;
    data = { client_id, monthly, product, channel };
  }
  try {
    const response = await axiosService.post(
      "/sales/incentive/sale-per-plan",
      data,
    );

    return response.data || response || [];
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getHayyak = async (client_id, month, year, channel) => {
  var monthly;
  var quarterly;
  var data;
  var channel = channel;
  var product = "Hayyak";
  if (month === "1Q" || month === "2Q" || month === "3Q" || month === "4Q") {
    quarterly = `${month.slice(0, 1)}-${year}`;
    data = { client_id, quarterly, product, channel };
  } else {
    monthly = `${month}-${year}`;
    data = { client_id, monthly, product, channel };
  }
  try {
    const response = await axiosService.post(
      "/sales/incentive/sale-per-plan",
      data,
    );

    return response.data || response || [];
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getBaqati = async (client_id, month, year, channel) => {
  var monthly;
  var quarterly;
  var data;
  var channel = channel;
  var product = "Baqati";
  if (month === "1Q" || month === "2Q" || month === "3Q" || month === "4Q") {
    quarterly = `${month.slice(0, 1)}-${year}`;
    data = { client_id, quarterly, product, channel };
  } else {
    monthly = `${month}-${year}`;
    data = { client_id, monthly, product, channel };
  }
  try {
    const response = await axiosService.post(
      "/sales/incentive/sale-per-plan",
      data,
    );

    return response.data || response || [];
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getUpgrade = async (client_id, month, year, channel) => {
  var monthly;
  var quarterly;
  var data;
  var channel = channel;
  var product = "Upgrade";
  if (month === "1Q" || month === "2Q" || month === "3Q" || month === "4Q") {
    quarterly = `${month.slice(0, 1)}-${year}`;
    data = { client_id, quarterly, product, channel };
  } else {
    monthly = `${month}-${year}`;
    data = { client_id, monthly, product, channel };
  }
  try {
    const response = await axiosService.post(
      "/sales/incentive/sale-per-plan",
      data,
    );

    return response.data || response || [];
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getOutletM = async (client_id, month, year) => {
  // var data = { "client_id": "69755" }
  var data = { client_id, ...getDateRequestData(month, year) };
  try {
    const response = await axiosService.post(
      "/sales/incentive/report_to_outlet_manager",
      data,
    );

    return response.data || response;
  } catch (error) {
    console.error(error);
  }
};
export const getManager = async (client_id, month, year, channel) => {
  // var data = { "client_id": "37864" }
  var data = { client_id, ...getDateRequestData(month, year), channel };
  try {
    const response = await axiosService.post(
      "/sales/incentive/report_to_manager",
      data,
    );

    return response.data || response || [];
  } catch (error) {
    console.error(error);
    return [];
  }
};
export const getSeniorM = async (client_id, month, year) => {
  // var data = { "client_id": "36177" }
  var data = { client_id, ...getDateRequestData(month, year) };
  try {
    const response = await axiosService.post(
      "/sales/incentive/report_to_senior_manager",
      data,
    );

    return response.data || response;
  } catch (error) {
    console.error(error);
  }
};
export const getGeneralM = async (client_id, month, year) => {
  // var data = { "client_id": "12050" }
  var data = { client_id, ...getDateRequestData(month, year) };
  try {
    const response = await axiosService.post(
      "/sales/incentive/report_to_general_manager",
      data,
    );

    return response.data || response || [];
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getVP = async (client_id, month, year) => {
  // var data = { "client_id": "34236" }
  var data = { client_id, ...getDateRequestData(month, year) };
  try {
    const response = await axiosService.post(
      "/sales/incentive/report_to_vice_president",
      data,
    );

    return response.data || response || [];
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getRegionPer = async (client_id, month, year) => {
  var monthly;
  var quarterly;
  var data;
  var product = "";
  if (month === "1Q" || month === "2Q" || month === "3Q" || month === "4Q") {
    quarterly = `${month.slice(0, 1)}-${year}`;
    data = { client_id, quarterly, product };
  } else {
    monthly = `${month}-${year}`;
    data = { client_id, monthly, product };
  }
  try {
    const response = await axiosService.post(
      "/sales/incentive/region_sales_target",
      data,
    );

    return response.data || response || [];
  } catch (error) {
    console.error(error);
    return [];
  }
};
export const getRegionSale = async (client_id, month, year) => {
  var monthly;
  var quarterly;
  var data;
  var product = "";
  if (month === "1Q" || month === "2Q" || month === "3Q" || month === "4Q") {
    quarterly = `${month.slice(0, 1)}-${year}`;
    data = { client_id, quarterly, product };
  } else {
    monthly = `${month}-${year}`;
    data = { client_id, monthly, product };
  }
  try {
    const response = await axiosService.post(
      "/sales/incentive/region_sales_count",
      data,
    );

    return response.data || response || [];
  } catch (error) {
    console.error(error);
    return [];
  }
};
export const getOutletByName = async (outlet, region, month, year) => {
  var monthly;
  var quarterly;
  var data;
  var product = "";
  if (month === "1Q" || month === "2Q" || month === "3Q" || month === "4Q") {
    quarterly = `${month.slice(0, 1)}-${year}`;
    data = { outlet, region, quarterly, product };
  } else {
    monthly = `${month}-${year}`;
    data = { outlet, region, monthly, product };
  }
  try {
    const response = await axiosService.post("/sales/incentive/get_user", data);

    return response.data || response || [];
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getTargetPerPlan = async (
  client_id,
  month,
  year,
  channel,
  plan_type = "",
) => {
  let monthly;
  let quarterly;
  let data;

  if (month === "1Q" || month === "2Q" || month === "3Q" || month === "4Q") {
    quarterly = `${month.slice(0, 1)}-${year}`;
    data = { client_id, quarterly, channel, plan_type };
  } else {
    monthly = `${month}-${year}`;
    data = { client_id, monthly, channel, plan_type };
  }

  try {
    const response = await axiosService.post(
      "/sales/incentive/target-chart-per-plan",
      data,
    );

    return response.data || response || [];
  } catch (error) {
    console.error(error);
    return [];
  }
};
